<template>
  <div class="main-content">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "TheContainer"
};
</script>
<style scoped>
.main-content {
  min-height: 300px;
}
</style>
